type Data = Record<string, string | number | boolean | null | undefined>;
const write = (level: "info" | "warn" | "error", event: string, data: Data = {}) => {
  const payload = { level, event, at: new Date().toISOString(), ...data };
  (level === "error" ? console.error : level === "warn" ? console.warn : console.info)(JSON.stringify(payload));
};
export const logger = { info: (event: string, data?: Data) => write("info", event, data), warn: (event: string, data?: Data) => write("warn", event, data), error: (event: string, data?: Data) => write("error", event, data) };
